<template>
  <div class="Warp">
    <van-cell-group>
      <van-divider content-position="center" style="margin-top:0;padding-top: 0.5rem;">基本信息</van-divider>
      <van-cell title="用户昵称" :value="list.cid?list.cid:'昵称'" />
      <van-cell title="点餐订单编号" :value="list.order_no" />
      <van-cell title="支付订单号" :value="list.out_trade_no" />
      <van-cell title="支付金额" :value="'￥'+list.money" />
      <van-cell
        title="桌号"
        :value="list.take_food_no"
      />
      <van-cell v-if="list.need_delivery==0" title="用餐类型" :value="list.type == 1 ? '堂食' : '打包'" />
      <van-cell v-if="list.need_delivery==1" title="用餐类型" value="外卖" />
      <van-cell v-if="list.need_delivery==1" title="配送费" :value="'￥'+list.delivery_money" />
      <van-cell v-if="list.need_delivery==1" title="配送信息">
        <div>{{list.detail}}</div>
        <div>{{list.name}}</div>
        <div>{{list.tel}}</div>
      </van-cell>

      <van-cell title="打包费" v-if="list.type == 2" :value="'￥'+list.pack_price" />
      <van-cell title="订单状态" v-if="list.order_status==-1" value="已取消" />
      <van-cell title="订单状态" v-else :value="['支付中','已支付','退款','部分退款'][list.order_status]" />
      <van-cell title="订单备注" :value="list.remark==''?'无备注':list.remark" />
      <van-cell title="添加时间" :value="list.add_time" />
      <van-divider content-position="center">菜品信息</van-divider>
      <div class="food" v-for="item in list.food" :key="item.food_id">
        <div class="img">
          <img :src="baseURL + item.picture" />
        </div>
        <div class="title">
          <p class="name">{{item.name}}</p>
          <p class="specs">{{item.specs}}</p>
          <p class="num">{{item.price}} x {{item.num}}</p>
        </div>
        <div class="price">
          <span>￥ {{item.price*item.num}}</span>
        </div>
      </div>
      <div>
        <van-divider content-position="center">支付信息</van-divider>
        <van-cell title="支付订单号" :value="list.pay.out_trade_no" v-if="list.pay" />
        <van-cell title="商户名称" :value="list.merchant_name" />
        <van-cell title="门店名称" :value="list.store_name" />
        <!-- <van-cell title="商户店名" :value="list.pay.trans_subject" /> -->
        <van-cell title="支付类型">
          <template #right-icon>
            <span style="color:#969799;">{{list.trans_type=="wxpay"?"微信":list.trans_type=="yue"?"余额":(list.trans_type=="alipay"?"支付宝":"云闪付")}}</span>
          </template>
        </van-cell>
        <van-cell title="发起时间" :value="list.add_time" />
        <van-cell title="完成时间" :value="list.pay_time" />
        <van-cell title="支付状态" v-if="list.order_status==-1" value="已取消" />
        <van-cell title="支付状态" v-else :value="['支付中','已支付','退款','部分退款'][list.order_status]" />
        <van-cell title="支付金额" :value="'￥'+list.money" />
      </div>
    </van-cell-group>
    <div style="margin: 16px;">
      <van-button
        v-if="list.order_status==0"
        @click="onPay"
        round
        block
        type="info"
        native-type="submit"
      >确认付款</van-button>
      <van-button
        v-if="list.order_status==0"
        @click="onCancel"
        round
        block
        type="danger"
        style="margin-top: 20px"
      >取消订单</van-button>
      <van-button
        v-if="list.order_status==1 || list.order_status==3"
        @click="partRefund"
        round
        block
        type="danger"
        style="margin-top: 20px"
      >订单退款</van-button>
      <van-button
        v-if="list.order_status==0"
        @click="partRefund"
        round
        block
        type="danger"
        style="margin-top: 20px"
      >退菜</van-button>
    </div>

    <van-popup v-model="show" round position="bottom" style="height: 300px;">
      <van-field label="支付方式">
        <template #input>
          <van-radio-group v-model="payType" direction="horizontal">
            <van-radio name="wxpay">微信</van-radio>
            <van-radio name="alipay">支付宝</van-radio>
            <van-radio name="unionpay">云闪付</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-button
        @click="onSubmit"
        round
        block
        type="info"
        native-type="submit"
        style="margin-top: 30px"
      >确认</van-button>
    </van-popup>
  </div>
</template>
<script>
import Config from "@/config";
import { Notify, Toast, Popup } from "vant";
export default {
  data() {
    return {
      show: false,
      page: 1,
      limit: 10,
      list: {},
      baseURL: Config.baseURL,
      loading: false,
      refreshLoading: false,
      finished: false,
      payType: "wxpay",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getOrderDetails();
  },
  methods: {
    getOrderDetails() {
      var that = this;
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http
        .post("/wechat/api.order/getOrder", { id: this.id })
        .then((response) => {
          this.list = response.body.data;
          console.log("2222222222", this.list);
          // console.log('11111111',response)
        });
    },
    onRefresh() {
      this.page = 1;
      this.list = {};
      this.finished = false;
      this.getOrderDetails();
    },
    uploader() {
      this.page++;
      this.getOrderDetails();
    },
    onPay() {
      this.show = true;
    },
    // 订单退款
    partRefund() {
      console.log(this.list.food);
      let obj = this.list.food;
      let parObj = JSON.stringify(obj);
      this.$router.push("/orderRefund/?id=" + this.id + "&obj=" + parObj);
    },
    onCancel() {
      this.$http
        .post("/wechat/api.order/cancelOrder", { order_id: this.id })
        .then((response) => {
          if (response && response.data.code == 200) {
            Notify({ type: "success", message: response.data.msg });
            this.getOrderDetails();
          } else {
            Notify({ type: "danger", message: response.data.msg });
          }
        });
    },
    onSubmit() {
      this.$http
        .post("/wechat/api.order/confirmOrder", {
          order_id: this.id,
          pay_type: this.payType,
        })
        .then((response) => {
          this.show = false;
          if (response && response.data.code == 200) {
            Notify({ type: "success", message: response.data.msg });
            this.getOrderDetails();
          } else {
            Notify({ type: "danger", message: response.data.msg });
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
.food {
  margin: 0.14rem 0.42667rem;
  font-size: 0.4rem;
  display: flex;
}
.food p {
  padding: 0;
  margin: 0;
}
.food img {
  width: 2rem;
  height: 100%;
  border-radius: 0.1rem;
}
.food .title {
  flex: 1;
  margin-left: 0.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.food .title .num,
.food .title .specs {
  font-size: 0.3rem;
  color: #999;
}
</style>
